import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import { BackButton } from '@/components/stashstr/BackButton';
import { Feed } from '@/components/stashstr/Feed';
import { FilterRows } from '@/pages/Top';
import {
  parseTopParams,
  timeframeToSince,
  type TopTimeframe,
  type TopMetric,
} from '@/hooks/useStashstrFeed';

export default function TerritoryPage() {
  const { tag, timeframe, metric } = useParams<{
    tag: string;
    timeframe?: string;
    metric?: string;
  }>();
  const location = useLocation();
  const navigate = useNavigate();

  const territory = (tag ?? '').toLowerCase();

  // Territory default is week (differs from /top which defaults to day).
  const timeframeParsed: TopTimeframe = timeframe ? parseTopParams(timeframe).timeframe : 'week';
  const metricParsed: TopMetric = metric ? parseTopParams(undefined, metric).metric : 'zaps';

  // Canonicalize invalid/missing segments: /t/nostr → /t/nostr/week/zaps etc.
  const canonical = `/t/${territory}/${timeframeParsed}/${metricParsed}`;
  useEffect(() => {
    if (location.pathname !== canonical) {
      navigate(canonical, { replace: true });
    }
  }, [location.pathname, canonical, navigate]);

  return (
    <div>
      <BackButton />
      <h1 className="text-[18px] font-bold text-gray-900 dark:text-gray-100 mb-2">~{territory}</h1>
      <FilterRows basePath={`/t/${territory}`} timeframe={timeframeParsed} metric={metricParsed} />
      <Feed
        sort="top"
        territory={territory}
        since={timeframeToSince(timeframeParsed)}
        topMetric={metricParsed}
      />
    </div>
  );
}
